import { render, staticRenderFns } from "./OilGoodsList.vue?vue&type=template&id=5bcc50dc&scoped=true&"
import script from "./OilGoodsList.vue?vue&type=script&lang=ts&"
export * from "./OilGoodsList.vue?vue&type=script&lang=ts&"
import style0 from "./OilGoodsList.vue?vue&type=style&index=0&id=5bcc50dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc50dc",
  null
  
)

export default component.exports